import { __DEV__ } from 'utils'

export const urlProxy = __DEV__ ? 'http://duva-cms-api.test/api/' : 'https://api.cms.duva.eu/api/'
export const urlBackend = __DEV__ ? 'http://duva-cms-api.test/' : 'https://api.cms.duva.eu/'
// export const urlProxy = 'http://127.0.0.1:8000/api/'
